import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, AppState } from '@nextgen-web-framework/core';
import { incrementOtpRequestCount, UsernameType } from '@commerce-identity-webcomponents/sdk';
import { useEffect } from 'react';
import OtpInputField from '../otp-input-field/OtpInputField';
import ResendOtpLink from '../resend-otp-link/ResendOtpLink';
import CountdownClock from '../countdown-clock/CountdownClock';
import OtpVerifiedLabel from '../otp-verified-label/OtpVerifiedLabel';
import OtpCheckingLabel from '../otp-checking-label/OtpCheckingLabel';
import OtpInvalidLabel from '../otp-invalid-label/OtpInvalidLabel';
import { isEmail } from '../../utils/helper';
import { VerifyCodeFormProps } from './types/propTypes';
import styles from './VerifyCodeForm.module.scss';

const VerifyCodeForm = ({ sendOtpNotification, autoverify = true, modeValue }: VerifyCodeFormProps) => {
  const { secondsLeft } = useSelector((state: AppState) => state.commerceIdentity.resendClockData);
  const dispatch = useDispatch<AppDispatch>();
  const { isChecking, isVerified, isInvalid } = useSelector((state: AppState) => state.commerceIdentity.otpData);
  const otpRequestCount = useSelector((state: AppState) => state.commerceIdentity.otpRequestCount);
  const modeValueType: UsernameType = isEmail('') ? UsernameType.EMAIL : UsernameType.PHONE;

  useEffect(() => {
    // on first load, the otp request was sent so we increment the count to 1
    dispatch(incrementOtpRequestCount());
  }, [dispatch]);

  const handleResendOtp = () => {
    dispatch(incrementOtpRequestCount());
    sendOtpNotification();
  };

  return (
    <div className={styles['identity-verify-otp-form']}>
      <div className={styles['layout-container']}>
        <OtpInputField name="otp" autoverify={autoverify} />
        <div className={styles['feedback-section']}>
          <div className="">
            {isVerified && <OtpVerifiedLabel />}
            {isChecking && <OtpCheckingLabel />}
            {isInvalid && !isChecking && (
              <OtpInvalidLabel otpRequestCount={otpRequestCount} userNameType={modeValueType} />
            )}
          </div>
          <div className="resend-section" data-testid="resend-section-test-id">
            {!isVerified && secondsLeft === 0 && <ResendOtpLink onClick={handleResendOtp} />}
            {!isVerified && secondsLeft > 0 && <CountdownClock />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyCodeForm;
